import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	noImageLabel: {
		id: 'company-hub.company-hub-common.unsplash-search.default-image-picker.no-image',
		defaultMessage: 'No image',
		description: 'Alt label for default unsplash pick with no image',
	},
});
